<template>
    <span>
        <r-button
            @click="showModal = true"
            :disabled="isProcessing"
            :loading="isProcessing" fluid>Update Renewal</r-button>
        <v-modal title="Update Renewal Date" @close="closeAndReset" v-if="showModal">
        <div slot="contents">
            <div class="modal-content">
               <p class="stack-m">
                   Update when the next billing attempt will be triggered
                for the subscription. This does not prorate the amount.
                   If you have set `Due Time Shift`, <b>Update Renewal</b> will override it.
               </p>
                <v-radio
                    class="stack-m"
                    group="renewalTime"
                    label="Now"
                    :value="false"
                    :model="isSpecificRenewalTime"
                    @update="changeRenewalType"/>
                <v-radio
                    class="stack-s"
                    group="renewalTime"
                    label="Specific Date"
                    :value="true"
                    :model="isSpecificRenewalTime"
                    @update="changeRenewalType"/>
                <v-date-input
                    v-if="isSpecificRenewalTime"
                    type="datetime"
                    :value="renewalTime"
                    :available-dates="availableDates"
                    @input="changeRenewalValue"/>
            </div>
        </div>
        <template slot="actions">
            <r-button
                type="primary"
                @click="updateOrderRenewal"
                :loading="isProcessing">Update</r-button>
        </template>
    </v-modal>
    </span>
</template>
<script>
    import {
        vCheckbox, vDateInput, vRadio,
    } from '@/components/form';
    import vModal from '@/components/modal/v-modal';

    export default {
        name: 'update-renewal',
        inject: ['setRenewalTime'],
        components: {
            vRadio,
            vModal,
            vDateInput,
            vCheckbox,
        },
        props: {
            order: Object,
        },
        data() {
            return {
                isProcessing: false,
                showModal: false,
                // renewalTime null or moment object. null === NOW, else specific date
                renewalTime: null,
            };
        },
        computed: {
            isSpecificRenewalTime() {
                return this.renewalTime !== null;
            },
            minimalAvailableDate() {
                return this.$tz().now().add(3, 'minute');
            },
            availableDates() {
                return {
                    start: this.minimalAvailableDate,
                    end: null,
                };
            },
        },
        methods: {
            closeAndReset() {
                this.showModal = false;
                this.renewalTime = null;
            },
            changeRenewalType(value) {
                this.renewalTime = value ? this.minimalAvailableDate : null;
            },
            changeRenewalValue(value) {
                this.renewalTime = value;
            },
            async updateOrderRenewal() {
                this.isProcessing = true;
                const {renewalTime} = this;
                this.closeAndReset();
                try {
                    const time = this.$tz().getRaw(renewalTime || this.$tz().now().add(3, 'minute'));
                    await this.setRenewalTime(time);
                } finally {
                    this.isProcessing = false;
                }
            },
        },
    };
</script>
